export enum AppRoutes {
  MAIN = 'main',
  AUTH = 'auth',
  LOGIN = 'login',

  GENERAL_SEARCH = 'general-search',
  CATALOG_SEARCH = 'catalog-search',
  CATALOG_UPLOAD = 'catalog-upload',
  CATALOG_MATCH_JOBS = 'catalog-match-jobs',
  CATALOG_MATCH_JOB_DETAILS = 'catalog-match-job-details',
  SIMILAR_PRODUCTS = 'similar-products',
  SIMILAR_PRODUCTS_JOB_DETAILS = 'similar-products-job-details',
  SUPPLIER_MANAGEMENT = 'suppliers',
  SUPPLIER_CATEGORY_MAPPINGS = 'supplier-category-mappings',
  BRAND_MANAGEMENT = 'brand-management',
  MANUFACTURER_MANAGEMENT = 'manufacturer-management',
  UOM_MANAGEMENT = 'uom',
  UOM_MANAGEMENT_LEGACY = 'uom-legacy',
  EXTERNAL_MATCHES = 'external-matches',

  // supplier catalog import
  SUPPLIER_CATALOG_FILES = 'supplier-catalog-files',
  SUPPLIER_CATALOG_JOB_DETAILS = 'supplier-catalog-job-details',
  SUPPLIER_CATALOG_JOB_DEBUG = 'supplier-catalog-job-debug',
  SUPPLIER_CATALOG_UPLOAD = 'supplier-catalog-upload',
  SUPPLIER_CATALOG_FERGUSON_ADHOC = 'supplier-catalog-ferguson-adhoc',

  // static pages
  PRIVACY_POLICY = 'privacy-policy',
  TERMS_OF_SERVICE = 'terms-of-service',
  PRIVACY_POLICY_EMBEDED = 'privacy-policy-embeded',
  TERMS_OF_SERVICE_EMBEDED = 'terms-of-service-embeded',

  // error pages
  FORBIDDEN = 'forbidden',
  ACCESS_DENIED = 'access-denied',
  NOT_FOUND_PAGE = 'not-found-page',

  // last
  NOT_FOUND = 'not-found',
}

export const getRouteMain = () => '/';
export const getRouteAuth = () => '/auth';
export const getRouteLogin = () => '/login';
export const getRouteGeneralSearch = () => `/general-search`;
export const getRouteCatalogSearch = () => `/catalog-search`;
export const getRouteCatalogUpload = () => `/catalog-upload`;
export const getRouteCatalogMatchJobs = () => `/catalog-match-jobs`;
export const getRouteCatalogMatchJobDetails = (jobId: string) =>
  `/catalog-match-jobs/${jobId}`;
export const getRouteSimilarProducts = () => `/similar-products`;
export const getRouteSimilarProductsJobDetails = (jobId: string) =>
  `/similar-products/${jobId}`;
export const getRouteSupplierManagement = () => `/suppliers`;
export const getRouteSupplierCategoryMappings = (supplierId: string) =>
  `/suppliers/${supplierId}/categories`;
export const getRouteBrandManagement = () => `/models/brands`;
export const getRouteManufacturerManagement = () => `/models/manufacturers`;
export const getRouteUomManagement = () => `/models/uom`;
export const getRouteUomManagementLegacy = () => `/uom`;
export const getRouteExternalMatches = () => `/external-matches`;
export const getRouteHome = () => '/general-search';

// Supplier Catalog Import routes
export const getRouteSupplierCatalogFiles = () => `/supplier-catalog/files`;
export const getRouteSupplierCatalogJobDetails = (jobId: string) =>
  `/supplier-catalog/jobs/${jobId}`;
export const getRouteSupplierCatalogJobDebug = (jobId: string, sku?: string) =>
  `/supplier-catalog/jobs/${jobId}/debug${
    sku ? `?sku=${encodeURIComponent(sku)}` : ''
  }`;
export const getRouteSupplierCatalogUpload = () => `/supplier-catalog/upload`;
export const getRouteSupplierCatalogFergusonAdhoc = () =>
  `/supplier-catalog/ferguson-adhoc`;

export const getRoutePrivacyPolicy = () => `/privacy-policy`;
export const getRouteTermsOfService = () => `/terms-of-service`;
export const getRoutePrivacyPolicyEmbeded = () => `/profile/privacy-policy`;
export const getRouteTermsOfServiceEmbeded = () => `/profile/terms-of-service`;

//error pages
export const getRouteAccessDenied = () => '/access-denied';
export const getRouteForbidden = () => '/forbidden';
export const getRouteNotFound = () => '/not-found';
